import { render, staticRenderFns } from "./configCommentsList.vue?vue&type=template&id=66ee13eb&scoped=true"
import script from "./configCommentsList.vue?vue&type=script&lang=js"
export * from "./configCommentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ee13eb",
  null
  
)

export default component.exports